import createReactComponent from '../createReactComponent';
export default createReactComponent('brand-inertia', 'IconBrandInertia', [
  ['path', { d: 'M12.5 8l4 4l-4 4h4.5l4 -4l-4 -4z', key: 'svg-0' }],
  ['path', { d: 'M3.5 8l4 4l-4 4h4.5l4 -4l-4 -4z', key: 'svg-1' }],
]);
